"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_common_1 = require("@apollo/react-common");
exports.ApolloProvider = react_common_1.ApolloProvider;
var react_hooks_1 = require("@apollo/react-hooks");
exports.useApolloClient = react_hooks_1.useApolloClient;
//# sourceMappingURL=ApolloProvider.js.map